import React from "react";
import DateField from "./DateField";

/**
 * DateRangeField — "Başlangıç / Bitiş" tarih ikilisi.
 *
 * Rapor ekranlarının tamamında aynı çift alan tekrarlıyordu; her biri kendi
 * grid'ini, etiketlerini ve boşluklarını kuruyordu. Tek yapı buraya alındı:
 * etiketler, ızgara ve alan ölçüsü her yerde aynı.
 *
 * @param {Date|null} startDate
 * @param {(d:Date|null)=>void} setStartDate
 * @param {Date|null} endDate
 * @param {(d:Date|null)=>void} setEndDate
 * @param {string} [startLabel="Başlangıç"] Boş string verilirse etiket çizilmez
 * @param {string} [endLabel="Bitiş"]
 * @param {string} [startPlaceholder] Etiketsiz (satır içi) kullanım için
 * @param {string} [endPlaceholder]
 * @param {"sm"|"md"|"lg"} [size="md"]
 * @param {boolean} [required]
 * @param {boolean} [disableFuture]
 * @param {number} [zIndex]
 * @param {boolean} [disablePortal]
 * @param {string} [className]  Izgara sarmalayıcısı (varsayılan 2 sütun)
 * @param {Date} [minDate] Seçilebilecek en erken gün (ör. firmanın / cihazın
 *   oluşturulma günü, #343) — öncesi iki alanda da seçilemez
 */
const laterOf = (a, b) => {
  if (!a) return b || undefined;
  if (!b) return a;
  return new Date(a) > new Date(b) ? a : b;
};

export default function DateRangeField({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  startLabel = "Başlangıç",
  endLabel = "Bitiş",
  startPlaceholder,
  endPlaceholder,
  size = "md",
  required = false,
  disableFuture = false,
  zIndex,
  disablePortal = false,
  className = "grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4",
  minDate,
}) {
  const shared = { size, required, disableFuture, disablePortal, ...(zIndex ? { zIndex } : {}) };
  return (
    <div className={className}>
      <DateField
        label={startLabel}
        placeholder={startPlaceholder}
        value={startDate}
        onChange={setStartDate}
        // Bitiş seçiliyse başlangıç onu geçemez — ters aralık seçilip boş
        // sonuç dönmesinin önüne geçer.
        maxDate={endDate || undefined}
        minDate={minDate || undefined}
        {...shared}
      />
      <DateField
        label={endLabel}
        placeholder={endPlaceholder}
        value={endDate}
        onChange={setEndDate}
        minDate={laterOf(startDate, minDate)}
        {...shared}
      />
    </div>
  );
}
